import Constants from '../../../common/utils/constants'

export interface NavigationItem {
  type?: string
  name: string
  url: string
  state?: Record<string, unknown>
  subs?: NavigationItem[][]
  modal?: boolean
}

export const navigations: NavigationItem[] = [
  {
    name: 'Our App',
    url: '/ourapp',
  },

  {
    name: 'Discover Law',
    url: '/discover-law',
    subs: [
      [
        {
          name: 'Commercial',
          url: '/legal-field/commercial',
          subs: [
            [
              {
                name: 'Commercial Agreements',
                url: '/legal-sub-field/commercial-agreements',
              },
            ],
          ],
        },
        {
          name: 'Data Protection',
          url: '/legal-field/data-protection',
          subs: [[]],
        },
        {
          name: 'General Partnership',
          url: '/legal-field/general-partnership',
          subs: [
            [
              {
                name: 'Partnership Act Provisions',
                url: '/legal-sub-field/partnership-act-provisions',
              },
              {
                name: 'Formation and Establishment',
                url: '/legal-sub-field/formation-and-establishment',
              },
            ],
          ],
        },
        {
          name: 'Privacy',
          url: '/legal-field/privacy',
          subs: [
            [
              {
                name: 'Privacy Compliance',
                url: '/legal-sub-field/privacy-compliance',
              },
            ],
          ],
        },
      ],
      [
        {
          name: 'Property',
          url: '/legal-field/property',
          subs: [
            [
              {
                name: 'Planning Permission',
                url: '/legal-sub-field/planning-permission',
              },
            ],
          ],
        },
        {
          name: 'Planning',
          url: '/legal-field/planning',
          subs: [
            [
              {
                name: 'Town and Country Planning Act Provisions',
                url: '/legal-sub-field/town-and-country-planning-act-provisions',
              },
              {
                name: 'Planning Applications and Permissions',
                url: '/legal-sub-field/planning-applications-and-permissions',
              },
            ],
          ],
        },
        {
          name: 'Wills and Probate',
          url: '/legal-field/wills-and-probate',
          subs: [
            [
              {
                name: 'Probate',
                url: '/legal-sub-field/probate',
              },
              {
                name: 'Contentious Probate',
                url: '/legal-sub-field/contentious-probate',
              },
              {
                name: 'Intestacy Rules',
                url: '/legal-sub-field/intestacy-rules',
              },
            ],
          ],
        },
        {
          name: 'Consumer',
          url: '/legal-field/consumer',
          subs: [[]],
        },
      ],
      [
        {
          name: 'Corporate',
          url: '/legal-field/corporate',
          subs: [[]],
        },
        {
          name: 'Estate Administration',
          url: '/legal-field/estate-administration',
          subs: [
            [
              {
                name: 'Estate Assets',
                url: '/legal-sub-field/estate-assets',
              },
            ],
          ],
        },
        {
          name: 'Employment',
          url: '/legal-field/employment',
          subs: [
            [
              {
                name: 'Employment Rights',
                url: '/legal-sub-field/employment-rights',
              },
              {
                name: 'Employee Data and Privacy',
                url: '/legal-sub-field/employee-data-and-privacy',
              },
            ],
          ],
        },
      ],
    ],
  },
  {
    name: 'Legal Help',
    url: '',
    subs: [
      [
        {
          name: 'Find a Lawyer',
          url: '/find-a-lawyer/search',
        },
        {
          name: 'Barristers',
          url: '/find-a-lawyer/search?profile_type=barrister',
        },
        {
          name: 'Solicitors',
          url: '/find-a-lawyer/search?profile_type=solicitor',
        },
        {
          name: 'Law Firms',
          url: '/find-a-lawyer/search?profile_type=lawfirm',
        },
        {
          name: 'Chambers',
          url: '/find-a-lawyer/search?profile_type=chamber',
        },
      ],
      [
        {
          name: 'Legal Docs',
          url: '/legal-documents',
        },
        {
          name: 'Templates',
          url: '/legal-documents?filter=template',
        },
        {
          name: 'Forms',
          url: '/legal-documents?filter=form',
        },
        {
          name: 'Letters',
          url: '/legal-documents?filter=letter',
        },
        {
          name: 'Notices',
          url: '/legal-documents?filter=notice',
        },
      ],
      [
        {
          name: 'Policy',
          url: '/legal-documents?filter=policy',
        },
        {
          name: 'English',
          url: '/legal-documents?filter=english',
        },
        {
          name: 'Welsh',
          url: '/legal-documents?filter=welsh',
        },
        {
          name: 'Scottish',
          url: '/legal-documents?filter=scottish',
        },
      ],
    ],
  },
  {
    name: 'Pricing',
    url: '/pricing',
  },
  {
    name: 'For Lawyers',
    url: '',
    subs: [
      [
        {
          name: 'Lawyer Portal',
          url: 'http://lawyers.legalutopia.co.uk',
        },
        {
          name: 'Pricing',
          url: '/pricing-lawyers',
        },
        {
          name: 'Market Indicators',
          url: 'http://qualityindicators.co.uk',
        },
        {
          name: 'Upskill My Pratice',
          url: 'http://upskillmypractice.co.uk',
        },
      ],
    ],
  },
  {
    name: 'Our Mission',
    url: '/our-mission',
  },
  {
    name: 'Contact us',
    url: '/contact-us',
    subs: [
      [
        {
          type: 'heading',
          name: 'Contact Methods',
          url: '',
        },
        {
          name: 'Message Us',
          url: '/contact-us',
        },
        {
          type: 'text',
          name: `Email: ${Constants.supportEmail}`,
          url: '',
        },

        {
          type: 'text',
          name: `Call Us: ${Constants.supportPhoneNumber}`,
          url: '',
        },
      ],
      [
        {
          type: 'heading',
          name: 'Newsletter',
          url: '',
        },
        {
          name: 'Receive Weekly Email',
          url: '',
          modal: true,
        },
      ],
    ],
  },
]
